import { z } from 'zod';
import { propertyLandAccessOptions } from '../constants/property-land-access.constant';

/** Validates editor input against its supported string custom-field choices. */
export const propertyLandAccessInputSchema = z.enum(propertyLandAccessOptions);
